





































import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import AuthService from '@/services/AuthService'
import store from '@/store'
import Auth from '@/store/modules/Auth'
import Setting from '@/store/modules/Setting'
import { getModule } from 'vuex-module-decorators'
import UserInfo from '@/store/modules/UserInfo'
import { loadAuthenticatedSessionData } from '@/helpers/loadAuthenticatedSession'

const SettingModule = getModule(Setting, store)
const AuthModule = getModule(Auth, store)
const UserModule = getModule(UserInfo, store)

@Component
export default class LineLogin extends Vue {
  private callback_url: any = window.location.origin + '/line-login/'
  private loginLineError: boolean = false

  created() {
    this.init()
  }

  init() {
    const data = new URLSearchParams()
    data.append('grant_type', 'authorization_code')
    data.append('code', this.$route.query.code as string)
    data.append('redirect_uri', this.callback_url)
    data.append('client_id', process.env.VUE_APP_LINE_CLIENT_ID)
    data.append('client_secret', process.env.VUE_APP_LINE_CLIENT_SECRET)
    axios
      .post('https://api.line.me/oauth2/v2.1/token', data)
      .then(response => {
        this.loginWithLine(response.data.id_token)
      })
      .catch(() => {
        this.loginLineError = true
      })
  }

  loginWithLine(id_token: string) {
    let data = {
      id_token: id_token
    }
    AuthService.loginWithLine(data)
      .then(response => {
        if (response.status === 200) {
          let token = response.data.access_token
          let user_id = response.data.user_id
          if (response.data.needs_acceptance) {
            localStorage.setItem('needs_acceptance', 'true')
          } else {
            localStorage.removeItem('needs_acceptance')
          }
          AuthModule.SET_NEW_TOKEN(token)
          UserModule.HANDLE_USER_ID(user_id)
        }
      })
      .catch(() => {
        this.loginLineError = true
      })
      .finally(() => this.handleRedirect())
  }

  handleRedirect() {
    AuthModule.SET_REDIRECT_LOGIN_WITH_LINE('')
  }

  checkUserBelongToGroup() {
    let path = '/'

    if (this.$store.state.auth.redirectLoginWithLine) {
      path = this.$store.state.auth.redirectLoginWithLine
    } else if (this.$route.query.redirect) {
      path = this.$route.query.redirect as string
    }
    AuthService.checkUserBelongToGroup()
      .then(response => {
        if (response.status === 200) {
          this.resetStoreToDefault()
          loadAuthenticatedSessionData()
          this.$router.push({ path: path })
          sessionStorage.setItem(
            'is_user_belong_to_group',
            response.data.is_user_belong_to_group
          )
        }
      })
      .catch(error => {
        sessionStorage.setItem('is_user_belong_to_group', 'false')
        if (error.response?.data?.is_request_join_group) {
          this.$bvModal.show('modal-info-login')
        } else {
          this.$router.push({ name: 'employee-without-group' })
          console.log(error)
        }
      })
  }

  resetStoreToDefault() {
    UserModule.RESET_DEFAULT()
    SettingModule.RESET_DEFAULT()
  }

  jumpToLogin() {
    this.$router.push({ name: 'login' })
  }
}
